import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';
import {
  useHasActiveVideoSession,
  useHasZeroEyesEvent,
} from '@rsos/reduxDataStore';
import useIsVT911CoreEnabled from '../../../hooks/useIsVT911CoreEnabled';
import useIsZeroEyesEnabled from '../../../hooks/useIsZeroEyesEnabled';
import {
  useHasAccessToDisplayMedia,
  useHasAccessToLiveVideo,
  useHasCallEnded,
  useSelectedMediaData,
  useSelectedVideoData,
} from './selectors/selectors';

const RedCircle = styled(Box)`
  background-color: ${({ theme }) => `${theme.colors.lightDanger}`};
  border-radius: 10px;
  display: inline-flex;
  height: 8px;
  margin-right: 4px;
  width: 8px;
`;

const StyledText = styled(Text).attrs({
  mt: '4px',
  size: 'small',
  textTransform: 'uppercase',
})``;

export const LiveVideoSession = ({ callerId }: { callerId: string }) => {
  const hasAccessToLiveVideo = useHasAccessToLiveVideo();
  const videoData = useSelectedVideoData(callerId);
  const hasCallEnded = useHasCallEnded(callerId);

  if (hasAccessToLiveVideo && !hasCallEnded && Object.keys(videoData).length) {
    return <StyledText color="success">Live Video Session</StyledText>;
  }
  return null;
};

export const VideoTo911Session = ({ callerId }: { callerId: string }) => {
  const isVT911CoreEnabled = useIsVT911CoreEnabled();
  const hasActiveVideoSession = useHasActiveVideoSession(callerId);

  if (isVT911CoreEnabled && hasActiveVideoSession) {
    return (
      <StyledText color="secondaryText">
        <RedCircle />
        Live Video
      </StyledText>
    );
  }

  return null;
};

export const ZeroEyesEvent = ({ callerId }: { callerId: string }) => {
  const hasZeroEyesEvent = useHasZeroEyesEvent(callerId);
  const isZeroEyesEnabled = useIsZeroEyesEnabled();

  if (hasZeroEyesEvent && isZeroEyesEnabled) {
    return <StyledText color="heavyWarning">ZeroEyes Gun Detected</StyledText>;
  }

  return <></>;
};

export const MediaAvailable = ({ callerId }: { callerId: string }) => {
  const hasAccessToDisplayMedia = useHasAccessToDisplayMedia();
  const mediaUploadData = useSelectedMediaData(callerId);
  if (hasAccessToDisplayMedia && mediaUploadData.length) {
    return <StyledText color="secondaryText">Media Available</StyledText>;
  }
  return null;
};
